import React, { useState } from 'react'
import { sendMessage } from 'services/messenger'
import { Checkbox, Spinner } from '@welbe/web-design-system'
import { PayPalCheckoutDetails } from '../PayPalCheckoutDetails/PayPalCheckoutDetails'
import { Modal } from '../Modal/Modal'
import {
	FormGroupSelect,
	FormGroupCheckbox,
	CardLabel,
	SelectInstallment,
	InstallmentError,
	Actions,
	Button,
	SpinnerButton,
} from './PayPalConfirmation.styles'
import { isIOS } from 'utils/device'

export const PayPalConfirmation = ({
	hostedFields,
	installmentOptions,
	installmentSelected,
	handleCaptureOrder,
	setInstallmentSelected,
	onErrorMsg,
	errorMessage,
	onValidFields,
	onEmptyFields,
	paypalOrder,
}: any): JSX.Element => {
	const [accepted, setAccepted] = useState(false)
	const [saveCard, setSaveCard] = useState(false)
	const [loading, setLoading] = useState<boolean>(false)
	const [isStallmentEmpty, setStallmentEmpty] = useState<boolean>(false)

	const checkFields = () => {
		const installmentField: any = document.getElementById('select-installment')
		const fields = hostedFields.getState().fields
		const items = ['number', 'cvv', 'expirationDate']
		const emptyFields = items.filter(item => fields[item].isEmpty)

		if (!installmentField.value) {
			emptyFields.push('installment')
			setStallmentEmpty(true)
		}
		const invalidItems = items.filter(item => !fields[item].isValid)
		onEmptyFields(emptyFields)
		onValidFields(invalidItems)

		return Boolean(invalidItems.length || emptyFields.length)
	}

	const submitHandler = async () => {
		if (checkFields()) return

		if (!hostedFields || typeof hostedFields.submit !== 'function') return
		onErrorMsg('')

		const vault = saveCard
		if (
			Object.values(hostedFields.getState().fields).some(
				(field: any) => !field.isValid,
			)
		) {
			onErrorMsg(
				'El formulario de pago no es válido, verifíquelo antes de ejecutar el pago.',
			)
			return
		}

		if (!installmentSelected) {
			onErrorMsg('Debes seleccionar un plazo de pago.')
			return
		}
		const installment = installmentOptions.find(
			(v: any) => v.key === installmentSelected,
		)

		if (
			!installment ||
			!installment.data.interval_duration ||
			!installment.data.term
		) {
			onErrorMsg('Debes seleccionar un plazo de pago.')
			return
		}

		const submitOptions = {
			vault,
			installments: {
				term: installment.data.term,
				intervalDuration: installment.data.interval_duration,
			},
		}

		setLoading(true)
		hostedFields
			.submit(submitOptions)
			.then(handleCaptureOrder)
			.catch((err: any) => {
				setLoading(false)
				sendMessage({
					status: 'error',
					data: {
						message: err?.message || 'Error al procesar el pago',
					},
				})
			})
			.finally(() => {
				setLoading(false)
			})
	}

	return (
		<>
			<FormGroupSelect>
				<CardLabel htmlFor="installments">Cuotas</CardLabel>
				<SelectInstallment
					value={installmentSelected}
					id="select-installment"
					onChange={(e: { target: { value: string } }) =>
						setInstallmentSelected(e.target.value)
					}
				>
					<option disabled value="">
						Seleccione la opción de pago
					</option>
					{installmentOptions.map((option: any) => (
						<option value={option.key} key={option.key}>
							{option.label}
						</option>
					))}
				</SelectInstallment>
				{isStallmentEmpty && !installmentSelected && (
					<InstallmentError className="installment-error">
						La opción de pago es obligatorio.
					</InstallmentError>
				)}
			</FormGroupSelect>
			<FormGroupCheckbox id="test" isIOS={isIOS()}>
				<Checkbox
					id="vault"
					name="vault"
					value={hostedFields?.getState()?.fields?.vault?.value || false}
					topDistance="3.2px"
					label="Guardar tarjeta"
					onChange={() => {
						setSaveCard(!saveCard)
					}}
				/>
			</FormGroupCheckbox>
			<PayPalCheckoutDetails
				onAccept={checked => setAccepted(checked)}
				paypalOrder={paypalOrder}
			/>
			{errorMessage && (
				<Modal
					onCancel={() =>
						sendMessage({
							status: 'cancel',
							data: { message: 'canceled-by-user', order: '' },
						})
					}
					onRetry={() => onErrorMsg('')}
				/>
			)}
			<Actions>
				<Button onClick={submitHandler} disabled={!accepted || loading}>
					{loading ? (
						<SpinnerButton>
							<Spinner backgroundColor="#fff" />
						</SpinnerButton>
					) : (
						'Pagar'
					)}
				</Button>
			</Actions>
		</>
	)
}
